import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Navimumbaiairporttolonavalacab() {



const cardData = {
  keyword: " Navi Mumbai Airport to Lonavala Cabs",

headingDescription:
  "Omshree Cab provides reliable and comfortable Navi Mumbai Airport to Lonavala cab services for travelers planning a relaxing hill station getaway in the Sahyadri mountains. Lonavala is one of the most popular weekend destinations near Mumbai and Pune, known for its scenic valleys, waterfalls, forts, and pleasant climate. Whether you are traveling for a family vacation, romantic trip, weekend outing, or corporate retreat, our cab service ensures a smooth and safe journey with experienced drivers and well-maintained vehicles. The distance from Navi Mumbai Airport to Lonavala is approximately 60–65 km and the journey usually takes around 1.5 to 2 hours via the Mumbai–Pune Expressway depending on traffic conditions. :contentReference[oaicite:0]{index=0} We provide flexible booking options including one-way transfers, round-trip packages, and full-day sightseeing trips with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual airport pickups, professional chauffeurs familiar with expressway routes, and 24/7 customer support, Omshree Cab is your trusted partner for Navi Mumbai Airport to Lonavala cab booking.",

topPlaces: [
  {
    title: "Bhushi Dam",
    description:
      "Bhushi Dam is one of the most famous tourist attractions in Lonavala, especially popular during the monsoon season. Visitors enjoy sitting on the stone steps as water flows over them, creating a refreshing natural experience. The surrounding hills and greenery make it a perfect spot for relaxation, photography, and short outings with friends and family. During rainy months the dam becomes a lively place where travelers gather to enjoy the cool mountain weather and flowing water. A cab journey from Navi Mumbai Airport allows visitors to comfortably reach Lonavala and spend quality time enjoying this scenic attraction."
  },
  {
    title: "Tiger Point",
    description:
      "Tiger Point, also known as Tiger’s Leap, is a breathtaking viewpoint located on the edge of a cliff overlooking deep valleys of the Western Ghats. The viewpoint offers spectacular panoramic views, especially during sunrise and sunset when the landscape appears dramatic and colorful. Visitors often stop here to enjoy the cool breeze, scenic views, and local snacks sold by nearby stalls. The surrounding mountains and misty valleys create a memorable sightseeing experience. Booking a cab from Navi Mumbai Airport allows travelers to easily include Tiger Point in their Lonavala sightseeing itinerary."
  },
  {
    title: "Lonavala Lake",
    description:
      "Lonavala Lake is a peaceful water body located near the town and becomes especially beautiful during the monsoon season when it fills with rainwater. The calm surroundings and scenic views attract tourists who enjoy relaxing walks, photography, and birdwatching near the lake. The area around the lake is surrounded by green hills which enhance the natural beauty of the destination. Visitors traveling from Navi Mumbai Airport can comfortably reach this quiet attraction by cab and spend time enjoying the serene environment."
  },
  {
    title: "Karla Caves",
    description:
      "Karla Caves are ancient Buddhist rock-cut caves dating back more than 2,000 years and are among the most historically significant attractions near Lonavala. The caves feature large prayer halls, stone pillars, and intricate carvings reflecting ancient Indian architecture and Buddhist heritage. Visitors climb a series of steps to reach the caves and explore the impressive structures carved directly into the hillside. History lovers and culture enthusiasts often include this destination in their travel plans when visiting Lonavala. A cab ride from Navi Mumbai Airport makes the journey convenient and comfortable."
  },
  {
    title: "Bhaja Caves",
    description:
      "Bhaja Caves are another group of ancient Buddhist rock-cut caves located near Lonavala and are believed to date back to the 2nd century BCE. The caves feature stupas, meditation halls, and beautifully carved sculptures that provide insight into early Buddhist culture and architecture. Visitors exploring the caves can also enjoy scenic views of the surrounding hills and valleys. Traveling by cab from Navi Mumbai Airport allows visitors to easily explore these historic caves during their Lonavala trip."
  },
  {
    title: "Rajmachi Fort",
    description:
      "Rajmachi Fort is a historic hill fort located near Lonavala and is popular among trekkers and history enthusiasts. The fort consists of two main structures, Shrivardhan and Manaranjan, which offer stunning views of the surrounding valleys and Sahyadri mountains. Visitors can trek through scenic forest trails and enjoy breathtaking landscapes from the fort’s summit. The combination of history, adventure, and nature makes Rajmachi Fort a must-visit destination in the region. A comfortable cab journey from Navi Mumbai Airport allows travelers to reach the base village and begin their exploration."
  },
  {
    title: "Lohagad Fort",
    description:
      "Lohagad Fort is one of the most famous forts near Lonavala and is known for its impressive architecture and historical significance during the Maratha Empire. The fort sits atop a hill and offers panoramic views of the surrounding mountains and valleys. Visitors often trek up the stone pathways to reach the top where they can explore ancient gates, walls, and watchtowers. The fort becomes especially scenic during the monsoon when the entire area is covered with lush greenery. Booking a cab from Navi Mumbai Airport provides convenient access to this popular trekking destination."
  },
  {
    title: "Kune Waterfalls",
    description:
      "Kune Waterfalls is a beautiful three-tier waterfall located between Lonavala and Khandala. Surrounded by dense greenery and hills, it is one of the most picturesque natural attractions in the region. The waterfall becomes especially spectacular during the monsoon season when water flows powerfully down the rocky cliffs. Visitors come here for photography, sightseeing, and enjoying the peaceful mountain atmosphere. Traveling by cab from Navi Mumbai Airport allows tourists to comfortably include this scenic waterfall in their Lonavala itinerary. :contentReference[oaicite:1]{index=1}"
  },
  {
    title: "Pawna Lake",
    description:
      "Pawna Lake is a scenic artificial lake located a short distance from Lonavala and is famous for lakeside camping and peaceful sunset views. Visitors often enjoy camping, bonfires, photography, and relaxing walks along the water’s edge. The calm environment surrounded by hills makes it an excellent location for weekend getaways and outdoor activities. Travelers arriving at Navi Mumbai Airport can book a cab to comfortably reach Pawna Lake and enjoy its natural beauty."
  },
  {
    title: "Della Adventure Park",
    description:
      "Della Adventure Park is one of the largest adventure parks near Lonavala offering a wide range of activities such as ziplining, ATV rides, dirt biking, rope courses, and adventure games. The park attracts families, groups, and adventure enthusiasts who want to experience thrilling outdoor activities. Along with adventure sports, the park also features restaurants and leisure facilities for visitors. Booking a cab from Navi Mumbai Airport ensures convenient travel to this exciting entertainment destination."
  }
],



services: [
{
name: "Navi Mumbai Airport to Lonavala Cab",
description: "Navi Mumbai Airport to Lonavala cab service provides comfortable and reliable transportation for travelers heading from Navi Mumbai International Airport to the popular hill station of Lonavala. The route through the Mumbai–Pune Expressway offers a scenic and smooth highway journey. Our fleet includes AC sedans, SUVs, and spacious MPV vehicles designed for comfortable intercity travel. Professional drivers ensure punctual airport pickup and safe driving throughout the journey. Pickup is available directly from airport terminals with luggage assistance. Ideal for tourists, families, and weekend travelers visiting Lonavala. Comfortable seating and smooth ride quality make the journey relaxing and enjoyable."
},
{
name: "Navi Mumbai Airport to Lonavala Taxi",
description: "Navi Mumbai Airport to Lonavala taxi service offers dependable transportation between the airport and Lonavala hill station. Vehicles provide comfortable seating and air-conditioned interiors suitable for highway journeys. Professional drivers ensure timely pickup from the airport terminal and safe travel along the expressway route. Pickup services include assistance with luggage and convenient drop at hotels or resorts in Lonavala. Ideal for tourists, families, and business travelers visiting the hill station. Flexible booking options allow passengers to plan their travel easily."
},
{
name: "Cab from Navi Mumbai Airport to Lonavala",
description: "Cab from Navi Mumbai Airport to Lonavala provides direct airport pickup and convenient transfer to the scenic hill station. Vehicles are well maintained and offer comfortable seating for relaxing travel. Professional drivers ensure safe driving along the highway route and punctual pickup services from airport arrival terminals. Spacious luggage capacity allows travelers to carry bags comfortably. Ideal for vacation trips, weekend getaways, and tourism travel."
},
{
name: "Taxi from Navi Mumbai Airport to Lonavala",
description: "Taxi from Navi Mumbai Airport to Lonavala provides comfortable airport transportation for passengers traveling to the famous hill station. Vehicles provide smooth ride quality and air-conditioned interiors suitable for long-distance travel. Professional drivers ensure punctual pickup from airport terminals and safe driving throughout the journey. Ideal for tourists visiting Lonavala resorts, families planning weekend trips, and travelers exploring nearby attractions."
},
{
name: "Navi Mumbai Airport Lonavala Cab Service",
description: "Navi Mumbai Airport Lonavala cab service provides convenient airport transfers for passengers traveling from Navi Mumbai airport to Lonavala hill station. Vehicles are clean, comfortable, and designed for highway travel. Professional drivers ensure timely pickups and smooth journeys along the expressway route. Pickup services are available directly from airport terminals with luggage assistance. Ideal for tourism travel and family vacations."
},
{
name: "Navi Mumbai Airport Lonavala Taxi Service",
description: "Navi Mumbai Airport Lonavala taxi service offers reliable intercity transportation between Navi Mumbai airport and the hill station of Lonavala. Vehicles provide comfortable seating and smooth ride performance suitable for highway journeys. Professional drivers ensure punctual pickup services and safe travel along the route. Ideal for tourists, corporate travelers, and weekend visitors."
},
{
name: "Navi Mumbai Airport to Lonavala Cab Booking",
description: "Navi Mumbai Airport to Lonavala cab booking allows travelers to reserve vehicles in advance for airport transfers. Online and phone booking options provide instant confirmation and flexible travel scheduling. Vehicles provide comfortable seating and reliable performance suitable for highway travel. Professional drivers ensure punctual airport pickup services."
},
{
name: "Navi Mumbai Airport to Lonavala Taxi Booking Online",
description: "Navi Mumbai Airport to Lonavala taxi booking online provides quick digital reservations for travelers planning airport transfers. Passengers can schedule rides online and receive instant booking confirmation. Vehicles offer comfortable seating and smooth ride quality suitable for the journey."
},
{
name: "Navi Mumbai Airport to Lonavala Cab Price",
description: "Navi Mumbai Airport to Lonavala cab price options provide transparent fare estimates based on vehicle type, travel distance, and trip duration. Travelers can choose sedans, SUVs, or MPV vehicles depending on comfort and group size. Clear pricing helps passengers plan their travel budget easily."
},
{
name: "Navi Mumbai Airport to Lonavala Taxi Fare",
description: "Navi Mumbai Airport to Lonavala taxi fare services offer flexible pricing depending on vehicle category and travel duration. Passengers can select economical sedans or spacious SUVs depending on their travel preferences. Transparent fare structure ensures clarity and easy booking."
},
{
name: "Navi Mumbai Airport to Lonavala One Way Cab",
description: "Navi Mumbai Airport to Lonavala one way cab service provides economical intercity travel without return charges. Vehicles offer comfortable seating and smooth highway performance suitable for expressway travel. Ideal for tourists and travelers planning a single-direction trip."
},
{
name: "Navi Mumbai Airport to Lonavala Round Trip Taxi",
description: "Navi Mumbai Airport to Lonavala round trip taxi service provides convenient transportation for passengers planning return travel. Vehicles remain available according to the travel plan ensuring comfortable transportation in both directions. Ideal for weekend trips and sightseeing tours."
},
{
name: "Hill Station Cab Lonavala Airport",
description: "Hill station cab Lonavala airport service provides comfortable transportation for travelers visiting Lonavala and nearby hill stations from Navi Mumbai Airport. Vehicles provide spacious seating and reliable highway performance suitable for scenic hill travel. Professional drivers ensure safe driving through the expressway and ghat sections."
},
{
name: "Innova Cab Navi Mumbai Airport Lonavala",
description: "Innova cab Navi Mumbai Airport Lonavala service provides spacious MPV transportation ideal for families and small groups traveling with luggage. Toyota Innova vehicles offer comfortable seating and smooth highway performance suitable for airport transfers and hill station journeys."
}
],

tableData: [
["Navi Mumbai Airport to Lonavala Cab","Navi Mumbai Airport to Lonavala Taxi"],
["Cab from Navi Mumbai Airport to Lonavala","Taxi from Navi Mumbai Airport to Lonavala"],
["Navi Mumbai Airport Lonavala Cab Service","Navi Mumbai Airport Lonavala Taxi Service"],
["Navi Mumbai Airport to Lonavala Cab Booking","Navi Mumbai Airport to Lonavala Taxi Booking Online"],
["Navi Mumbai Airport to Lonavala Cab Price","Navi Mumbai Airport to Lonavala Taxi Fare"],
["Navi Mumbai Airport to Lonavala One Way Cab","Navi Mumbai Airport to Lonavala Round Trip Taxi"],
["Hill Station Cab Lonavala Airport","Innova Cab Navi Mumbai Airport Lonavala"]
],


whychoose: [
  {
    WhyChooseheading: "Experienced Hill Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in driving through the scenic ghat roads from Navi Mumbai Airport to Lonavala. They understand the hill routes, curves, and traffic conditions ensuring a safe and smooth journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Navi Mumbai Airport to Lonavala cab bookings. Customers receive clear information about travel fares, toll charges, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Airport Pickup Service",
    WhyChoosedescription: "Our Navi Mumbai Airport to Lonavala cab service operates 24 hours a day. Whether your flight arrives early morning or late night, we provide reliable airport pickup anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, fully air-conditioned, and regularly cleaned to ensure passengers enjoy a comfortable hill station journey."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Options",
    WhyChoosedescription: "We offer flexible travel options including one-way cab bookings, round trips, and same-day return packages between Navi Mumbai Airport and Lonavala."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs provides a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for couples, families, and group travelers."
  },
  {
    WhyChooseheading: "Direct Airport Pickup",
    WhyChoosedescription: "Our drivers provide convenient pickup directly from Navi Mumbai Airport terminals and assist passengers with luggage for a comfortable start to the Lonavala journey."
  },
  {
    WhyChooseheading: "Trusted Hill Station Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Navi Mumbai Airport to Lonavala trips thanks to our punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Navi Mumbai Airport to Lonavala?", answer: "Yes, Omshree Cabs provides reliable cab services from Navi Mumbai Airport to Lonavala for both one-way and round-trip travel." },
  { question: "What is the distance from Navi Mumbai Airport to Lonavala?", answer: "The distance from Navi Mumbai Airport to Lonavala is approximately 90 km and the journey usually takes around 1.5 to 2 hours depending on traffic." },
  { question: "Can I book a one-way cab from Navi Mumbai Airport to Lonavala?", answer: "Yes, we offer both one-way and round-trip cab services between Navi Mumbai Airport and Lonavala." },
  { question: "Which vehicles are available for this route?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on passenger requirements." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7 to match flight arrival schedules." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can we stop during the journey for sightseeing?", answer: "Yes, passengers can request stops during the journey for meals, refreshments, or sightseeing points in Lonavala." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and tourist seasons." },
  { question: "Do drivers track flight arrival times?", answer: "Yes, our drivers monitor flight schedules to ensure timely pickup even if flights are delayed." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Shah",
    feedback:
      "We booked Omshree Cabs from Navi Mumbai Airport to Lonavala. The driver was punctual and the journey through the ghats was very smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Desai",
    feedback:
      "Excellent cab service for Lonavala travel. Clean vehicle, polite driver, and comfortable ride from Navi Mumbai Airport.",
    rating: 5
  }
];









































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Navi Mumbai Airport to Lonavala Cabs",
  "description": "Omshree Cab provides reliable cab services from Navi Mumbai Airport to Lonavala. Book Innova, Ertiga, or sedan cabs online for one-way or round trips, perfect for hill station trips and corporate travel.",
  "provider": {
    "@type": "Organization",
    "name": "Omshree Cab",
    "telephone": "+91 9892544084",
    "url": "https://www.omshreecab.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai"
  },
  "serviceType": "Airport to Hill Station Cab Service"
};










  return (
    <div>
      
<Helmet>
  <title>Navi Mumbai Airport to Lonavala Cabs | Omshree Cab Booking</title>
  <meta 
    name="description" 
    content="Book cabs from Navi Mumbai Airport to Lonavala with Omshree Cab. Choose Innova, Ertiga, or sedan for comfortable one-way or round trip rides to Lonavala hill station. Available online booking 24x7." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/86.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaiairporttolonavalacab;